import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { LogOut, FileText, Inbox, ExternalLink, ShoppingBag } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = async () => {
    await logout();
    navigate("/admin/login");
  };

  return (
    <div className="admin-shell flex flex-col">
      <header
        className="w-full"
        style={{ background: "var(--ldr-red)" }}
        data-testid="admin-navbar"
      >
        <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
          <Link
            to="/admin/reembolsos"
            className="text-white font-bold uppercase tracking-[0.16em] text-base"
            data-testid="admin-brand-link"
          >
            Lendas do Rock <span className="opacity-70 font-normal ml-1 text-xs">/ Backoffice</span>
          </Link>
          <div className="flex items-center gap-5">
            <a
              href="/"
              target="_blank"
              rel="noreferrer"
              className="hidden sm:inline-flex items-center gap-1 text-white/90 text-xs uppercase tracking-wider hover:text-white"
              data-testid="admin-view-site-link"
            >
              Ver site <ExternalLink size={14} />
            </a>
            <span className="hidden md:inline text-white/80 text-xs" data-testid="admin-user-email">
              {user && user.email}
            </span>
            <button
              type="button"
              onClick={onLogout}
              className="text-white text-sm inline-flex items-center gap-2 border border-white/40 rounded-md px-3 py-1.5 hover:bg-white/10 transition"
              data-testid="admin-logout-btn"
            >
              <LogOut size={14} /> Sair
            </button>
          </div>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 w-full flex-1 flex flex-col md:flex-row gap-8 py-8">
        <aside className="md:w-56 shrink-0">
          <nav className="flex md:flex-col gap-1 md:gap-2" data-testid="admin-sidebar">
            <SideLink to="/admin/reembolsos" icon={<FileText size={16} />} testid="side-reembolsos">
              Reembolsos
            </SideLink>
            <SideLink to="/admin/encomendas" icon={<ShoppingBag size={16} />} testid="side-encomendas">
              Encomendas
            </SideLink>
            <SideLink to="/admin/contactos" icon={<Inbox size={16} />} testid="side-contactos">
              Contactos
            </SideLink>
          </nav>
        </aside>

        <main className="flex-1 min-w-0">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

function SideLink({ to, icon, children, testid }) {
  return (
    <NavLink
      to={to}
      end={false}
      data-testid={testid}
      className={({ isActive }) =>
        [
          "flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-colors",
          isActive
            ? "bg-white text-[var(--ldr-red)] border border-[var(--ldr-border)]"
            : "text-[var(--ldr-text)] hover:bg-white hover:text-[var(--ldr-red)]",
        ].join(" ")
      }
    >
      {icon}
      {children}
    </NavLink>
  );
}
